import React from "react"

import ContentLoaderTags from "../../common/content-loading/ContentLoaderTags"
import ConceptTag from "./ConceptTag"

const FeedItemConceptDetails = ({
    header = "Concepts",
    concepts,
    canEdit,
    isFetching
}) => (
    <div className="widget">
        <h3 className="widget-header">
            <span className="icon icon-concepts" />
            {header}
            <span className="widget-header-info">{concepts.length}</span>
        </h3>
        <div className="widget-content tags concepts-box clearfix auto">
            <ContentLoaderTags
                isFetching={isFetching}
                minLines={2}
                maxLines={6}
            >
                {concepts.map(concept => (
                    <ConceptTag
                        parentPrefix={header}
                        concept={concept}
                        canEdit={canEdit}
                        key={concept.id}
                        hasWikipediaPage={true}
                        uri={`https://en.wikipedia.org/wiki/${concept.id}`}
                    />
                ))}
            </ContentLoaderTags>
        </div>
    </div>
)
export default FeedItemConceptDetails
